<template>
  <div class="margin-subpages">
    <div class="flex-row-between mt-24">
      <el-select v-model="selectTeam" filterable :placeholder="$t('skills.proficiencies.select_placeholder')" class="input-style"
      :class="[ blurMode ?  'blurelement': '' ]" @change="handleTeams">
        <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown" key="all" :label="`${$t('skills.proficiencies.all_teams')} (${$utils(
        'addCommasInNumber',
        optionsTeam.length
      )})`" value="all"></el-option>
        <el-option class="text-dropdown"
        :class="[ blurMode ?  'blurelement': '' ]"v-for="item in optionsTeam" :key="item.key" :label="item.name"
          :value="item.key"></el-option>
      </el-select>
      <div style="width: 220px" id="menuDropdownType" class="flex">
        <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
          <el-submenu index="0" style="width: 220px">
            <template slot="title">
              <span class="txtOption">{{ list_month_select }} </span>
            </template>
            <el-menu-item index="1" @click="changeTime('Current month')" style="font-size: 14px; width: 220px">{{ $t('skills.proficiencies.current_month') }}</el-menu-item>
            <el-menu-item index="2" @click="changeTime('Last month')" style="font-size: 14px; width: 220px">{{ $t('skills.proficiencies.last_month') }}</el-menu-item>
            <el-menu-item index="3" @click="changeTime('Past 3-months')" style="font-size: 14px; width: 220px">{{ $t('skills.proficiencies.past_3_months') }}</el-menu-item>
            <el-menu-item index="4" @click="changeTime('Past 6-months')" style="font-size: 14px; width: 220px">{{ $t('skills.proficiencies.past_6_months') }}</el-menu-item>
            <el-menu-item index="5" @click="changeTime('Past year')" style="font-size: 14px; width: 220px">{{ $t('skills.proficiencies.past_year') }}</el-menu-item>
            <el-menu-item index="6" @click="changeTime('All-time')" style="font-size: 14px; width: 220px">{{ $t('skills.proficiencies.all_time') }}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>


    <div id="byManager">
      <div class="mt-24 fs-18 fw-700">{{ $t('skills.proficiencies.overview') }}</div>
      <div class="overview mt-20">
        <div class="icon-buttom-loading flex-mid" v-if="loading">
          <loading-even></loading-even>
        </div>
        <div v-else class="rating-grid">
          <div class="rating-col">
            <div class="fs-14 fw-700">{{ $t('skills.proficiencies.rating_overview') }}</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">{{ $t('skills.proficiencies.rating_overview_description') }}</div>
            <div v-if="ratingTotals.total === 0" class="rating-empty">{{ $t('skills.proficiencies.no_ratings') }}</div>
            <template v-else>
              <div class="rating-stats">
                <div class="rating-stat">
                  <span class="rating-stat-value">{{ ratingTotals.avg.toFixed(1) }}<span class="star-rating is-lg"><span class="stars"><span class="stars-bg">★★★★</span><span class="stars-fg" :style="{ width: starWidth(ratingTotals.avg) }">★★★★</span></span></span></span>
                  <el-tooltip :content="$t('skills.proficiencies.average_rating_hint')" placement="top">
                    <span class="rating-stat-label behaviors-th">{{ $t('skills.proficiencies.average_rating') }}</span>
                  </el-tooltip>
                </div>
                <div class="rating-stat">
                  <span class="rating-stat-value">{{ $utils("addCommasInNumber", ratingTotals.total) }}</span>
                  <span class="rating-stat-label">{{ $t('skills.proficiencies.total_ratings') }}</span>
                </div>
              </div>
              <div class="rating-bar">
                <div v-for="tier in ratingTiers" :key="tier.key" v-show="tier.count > 0" class="rating-bar-seg"
                  :style="{ width: tierPercent(tier) + '%', background: tier.color }"></div>
              </div>
              <div class="rating-legend">
                <div v-for="tier in ratingTiers" :key="'legend_' + tier.key" class="rating-legend-row">
                  <span class="rating-legend-swatch" :style="{ background: tier.color }"></span>
                  <span class="rating-legend-label">{{ $t('skills.proficiencies.' + tier.key) }}</span>
                  <span class="rating-legend-count">{{ $utils("addCommasInNumber", tier.count) }}</span>
                  <span class="rating-legend-pct">{{ tierPercent(tier) }}%</span>
                </div>
              </div>
            </template>
          </div>

          <div class="rating-col">
            <div class="fs-14 fw-700">{{ $t('skills.proficiencies.highest_rated') }}</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">{{ $t('skills.proficiencies.highest_rated_description') }}</div>
            <div v-if="highest.length === 0" class="rating-empty">{{ $t('skills.proficiencies.no_ratings') }}</div>
            <template v-else>
              <div v-for="(val, index) in highest.slice(0, 5)" :key="val.emailKey" class="rated-row">
                <div class="rated-rank">{{ index + 1 }}</div>
                <img v-if="val.profilepic" v-lazy="val.profilepic" :key="val.profilepic"
                  class="image-skeleton image-profile-32 flex-mid"
                  :class="[ blurMode ? 'blurelement' : '' ]" />
                <div v-else class="image image-profile-32 flex-mid"
                  :class="[ blurMode ? 'blurelement' : '' ]">
                  <div class="text-in-image text-in-image-32 flex-mid">
                    {{ $utils("acronymName", { firstName: val.firstname, lastName: val.lastname }) }}
                  </div>
                </div>
                <div class="rated-who">
                  <span class="rated-name" :class="[ blurMode ? 'blurelement' : '' ]">{{ val.firstname }} {{ val.lastname }}</span>
                  <span class="rated-team" :class="[ blurMode ? 'blurelement' : '' ]">{{ val.teamname }}</span>
                </div>
                <div class="rated-score">
                  <span class="rated-rating">{{ val.ratingavg }}<span class="rating-denom">/ 4</span></span>
                  <span class="rated-count">{{ val.total }} {{ $t('skills.proficiencies.ratings_label') }}</span>
                </div>
              </div>
              <div class="rated-see-all" @click="openModalMember(highest, 'highest')">
                {{ $t('skills.proficiencies.see_all') }} <i class="el-icon-arrow-right"></i>
              </div>
            </template>
          </div>

          <div class="rating-col">
            <div class="fs-14 fw-700">{{ $t('skills.proficiencies.lowest_rated') }}</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">{{ $t('skills.proficiencies.lowest_rated_description') }}</div>
            <div v-if="lowest.length === 0" class="rating-empty">{{ $t('skills.proficiencies.no_ratings') }}</div>
            <template v-else>
              <div v-for="(val, index) in lowest.slice(0, 5)" :key="val.emailKey" class="rated-row">
                <div class="rated-rank">{{ index + 1 }}</div>
                <img v-if="val.profilepic" v-lazy="val.profilepic" :key="val.profilepic"
                  class="image-skeleton image-profile-32 flex-mid"
                  :class="[ blurMode ? 'blurelement' : '' ]" />
                <div v-else class="image image-profile-32 flex-mid"
                  :class="[ blurMode ? 'blurelement' : '' ]">
                  <div class="text-in-image text-in-image-32 flex-mid">
                    {{ $utils("acronymName", { firstName: val.firstname, lastName: val.lastname }) }}
                  </div>
                </div>
                <div class="rated-who">
                  <span class="rated-name" :class="[ blurMode ? 'blurelement' : '' ]">{{ val.firstname }} {{ val.lastname }}</span>
                  <span class="rated-team" :class="[ blurMode ? 'blurelement' : '' ]">{{ val.teamname }}</span>
                </div>
                <div class="rated-score">
                  <span class="rated-rating">{{ val.ratingavg }}<span class="rating-denom">/ 4</span></span>
                  <span class="rated-count">{{ val.total }} {{ $t('skills.proficiencies.ratings_label') }}</span>
                </div>
              </div>
              <div class="rated-see-all" @click="openModalMember(lowest, 'lowest')">
                {{ $t('skills.proficiencies.see_all') }} <i class="el-icon-arrow-right"></i>
              </div>
            </template>
          </div>
        </div>

      </div>
      <div class="mt-30 fs-18 fw-700">{{ $t('skills.proficiencies.skills_proficiency') }}</div>
      <div class="skill-Profictency mt-20">
        <div class="icon-buttom-loading flex-mid" v-if="loading">
          <loading-even></loading-even>
        </div>
        <div v-else class="sb-wrap p-24">
          <div class="fs-14 fw-700">{{ $t('skills.proficiencies.strengths_title') }}</div>
          <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">{{ $t('skills.proficiencies.strengths_description') }}</div>
          <div v-if="topSkillRows.length === 0" class="sb-empty">{{ $t('skills.proficiencies.no_skill_mentions') }}</div>
          <div v-else class="sb-chart">
            <div class="sb-head">
              <div class="sb-skill"></div>
              <div class="sb-track">
                <div class="sb-side is-dev">
                  <span class="sb-axis-label"><span class="swatch is-dev"></span>{{ $t('skills.proficiencies.development_areas') }}</span>
                </div>
                <div class="sb-axis"></div>
                <div class="sb-side is-str">
                  <span class="sb-axis-label">{{ $t('skills.proficiencies.strengths') }}<span class="swatch is-str"></span></span>
                </div>
              </div>
            </div>
            <div v-for="skill in topSkillRows" :key="'sb_' + skill.name" class="sb-row">
              <div class="sb-skill">
                <span class="sb-skill-name cursor-pointer" @click="openModalDetails(skill.data)">{{ skill.name }}</span>
              </div>
              <div class="sb-track">
                <div class="sb-side is-dev">
                  <span v-if="showDeltas && skill.improve > 0" class="sb-delta"
                    :style="`color: ${skill.compareimprove > 0 ? '#1AC362' : '#F44336'};`">{{ skill.compareimprove > 0 ? `+${skill.compareimprove}` : skill.compareimprove }}</span>
                  <span v-if="skill.improve > 0" class="sb-count">{{ skill.improve }}</span>
                  <el-tooltip v-if="skill.improve > 0" :content="skillTooltip(skill.improve, skill.developPeople)" placement="top">
                    <div class="sb-bar is-dev" :style="{ width: barWidth(skill.improve) }"></div>
                  </el-tooltip>
                </div>
                <div class="sb-axis"></div>
                <div class="sb-side is-str">
                  <el-tooltip v-if="skill.excel > 0" :content="skillTooltip(skill.excel, skill.strengthPeople)" placement="top">
                    <div class="sb-bar is-str" :style="{ width: barWidth(skill.excel) }"></div>
                  </el-tooltip>
                  <span v-if="skill.excel > 0" class="sb-count">{{ skill.excel }}</span>
                  <span v-if="showDeltas && skill.excel > 0" class="sb-delta"
                    :style="`color: ${skill.compareexcel > 0 ? '#1AC362' : '#F44336'};`">{{ skill.compareexcel > 0 ? `+${skill.compareexcel}` : skill.compareexcel }}</span>
                </div>
              </div>
            </div>
            <div v-if="skillBalance.length > topSkillRows.length" class="sb-footnote">
              {{ $t('skills.proficiencies.showing_top_skills') }} · {{ topSkillRows.length }}/{{ skillBalance.length }}
            </div>
          </div>
        </div>
      </div>

      <!-- Feedback behaviors by person -->
      <div class="mt-30 fs-18 fw-700">{{ $t('skills.proficiencies.behaviors_title') }}</div>
      <div class="behaviors-card mt-20">
        <div class="behaviors-header">
          <div class="fs-12" style="color: #000000; opacity: 0.6; max-width: 480px;">{{ $t('skills.proficiencies.behaviors_description') }}</div>
          <div v-if="!behaviorLoading" class="behaviors-stats">
            <div class="behaviors-stat">
              <span class="stat-value">{{ formatNumber(behaviorTotals.requested) }}</span>
              <span class="stat-label">{{ $t('skills.proficiencies.requests_made') }}</span>
            </div>
            <div class="behaviors-stat">
              <span class="stat-value">{{ formatNumber(behaviorTotals.given) }}</span>
              <span class="stat-label">{{ $t('skills.proficiencies.feedback_given') }}</span>
            </div>
            <div class="behaviors-stat">
              <span class="stat-value">{{ behaviorTotals.participation }}%</span>
              <el-tooltip :content="$t('skills.proficiencies.participation_hint')" placement="top">
                <span class="stat-label behaviors-th">{{ $t('skills.proficiencies.participation') }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div class="behaviors-toolbar">
          <span class="behaviors-meta">{{ formatNumber(scopedBehaviorRows.length) }} {{ $t('skills.proficiencies.members_label') }}</span>
          <el-input
            v-model="behaviorSearch"
            class="behaviors-search"
            prefix-icon="el-icon-search"
            :placeholder="$t('members.Search')"
            clearable
            @input="behaviorPage = 1"
          ></el-input>
        </div>

        <div v-if="behaviorLoading" class="loading-placeholder">
          <i class="el-icon-loading"></i> {{ $t('skills.proficiencies.loading_behaviors') }}
        </div>
        <template v-else>
          <el-table
            id="behaviorsTable"
            :data="pagedBehaviorRows"
            :empty-text="$t('skills.proficiencies.no_behaviors')"
            @sort-change="sortBehaviors"
          >
            <el-table-column prop="name" sortable="custom" :label="$t('members.Member')" min-width="220">
              <template slot-scope="scope">
                <div class="behaviors-member">
                  <img v-if="scope.row.profilepic" v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                    class="image-skeleton image-profile-42 flex-mid"
                    :class="[ blurMode ? 'blurelement' : '' ]" />
                  <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ? 'blurelement' : '' ]">
                    <div class="text-in-image text-in-image-42 flex-mid">
                      {{ $utils("acronymName", { firstName: scope.row.firstname, lastName: scope.row.lastname }) }}
                    </div>
                  </div>
                  <div class="behaviors-member-text">
                    <span class="behaviors-name" :class="[ blurMode ? 'blurelement' : '' ]">{{ scope.row.firstname }} {{ scope.row.lastname }}</span>
                    <span class="behaviors-team" :class="[ blurMode ? 'blurelement' : '' ]">{{ scope.row.teamname }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('skills.proficiencies.receiving_feedback')" align="center">
              <el-table-column prop="requested" sortable="custom" width="124" align="center">
                <template slot="header">
                  <el-tooltip :content="$t('skills.proficiencies.requested_hint')" placement="top">
                    <span class="behaviors-th">{{ $t('skills.proficiencies.requested') }}</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span class="behaviors-count" :class="{ 'is-zero': scope.row.requested === 0 }">{{ scope.row.requested }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="received" sortable="custom" width="106" align="center">
                <template slot="header">
                  <el-tooltip :content="$t('skills.proficiencies.received_hint')" placement="top">
                    <span class="behaviors-th">{{ $t('skills.proficiencies.received') }}</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span class="behaviors-count" :class="{ 'is-zero': scope.row.received === 0 }">{{ scope.row.received }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="$t('skills.proficiencies.giving_feedback')" align="center">
              <el-table-column prop="asked" sortable="custom" width="94" align="center">
                <template slot="header">
                  <el-tooltip :content="$t('skills.proficiencies.asked_hint')" placement="top">
                    <span class="behaviors-th">{{ $t('skills.proficiencies.asked') }}</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span class="behaviors-count" :class="{ 'is-zero': scope.row.asked === 0 }">{{ scope.row.asked }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="given" sortable="custom" width="94" align="center">
                <template slot="header">
                  <el-tooltip :content="$t('skills.proficiencies.given_hint')" placement="top">
                    <span class="behaviors-th">{{ $t('skills.proficiencies.given') }}</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span class="behaviors-count" :class="{ 'is-zero': scope.row.given === 0 }">{{ scope.row.given }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="responseRate" sortable="custom" width="118" align="center">
                <template slot="header">
                  <el-tooltip :content="$t('skills.proficiencies.response_rate_hint')" placement="top">
                    <span class="behaviors-th">{{ $t('skills.proficiencies.response_rate') }}</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span v-if="scope.row.responseRate !== null" class="behaviors-rate">{{ scope.row.responseRate }}%</span>
                  <span v-else class="behaviors-count is-zero">—</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="ratingavg" sortable="custom" width="104" align="center">
              <template slot="header">
                <el-tooltip :content="$t('skills.proficiencies.average_rating_hint')" placement="top">
                  <span class="behaviors-th">{{ $t('skills.proficiencies.rating_short') }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.ratingavg !== null" class="behaviors-rating">{{ scope.row.ratingavg.toFixed(1) }}<span class="rating-denom">/ 4</span></span>
                <span v-else class="behaviors-count is-zero">—</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="filteredBehaviorRows.length > behaviorPageSize" class="behaviors-pagination">
            <el-pagination
              @current-change="changeBehaviorPage"
              :current-page="behaviorPage"
              :page-size="behaviorPageSize"
              :pager-count="5"
              layout="prev, pager, next"
              :total="filteredBehaviorRows.length"
            ></el-pagination>
          </div>
        </template>
      </div>

    </div>



    <div class="remove-padding-modal">
      <el-dialog :visible.sync="detailsModalStatus" width="1100px" top="8vh">
        <div class="sd-wrap">
          <div class="sd-header">
            <div class="sd-eyebrow">{{ $t('skills.proficiencies.skill_details') }}</div>
            <div class="sd-title">{{ skillsModalData.name }}</div>
            <div v-if="modalSplit.total > 0" class="sd-mentions">
              <div class="sd-mention-stat">
                <span class="n">{{ skillsModalData.excel }}</span>
                <span class="label"><span class="swatch is-str"></span>{{ $t('skills.proficiencies.strength_mentions') }}</span>
              </div>
              <div class="sd-mention-bar">
                <div v-if="modalSplit.excel > 0" class="seg is-str" :style="{ width: modalSplit.excel + '%' }"></div>
                <div v-if="modalSplit.improve > 0" class="seg is-dev" :style="{ width: modalSplit.improve + '%' }"></div>
              </div>
              <div class="sd-mention-stat is-end">
                <span class="n">{{ skillsModalData.improve }}</span>
                <span class="label">{{ $t('skills.proficiencies.development_mentions') }}<span class="swatch is-dev"></span></span>
              </div>
            </div>
          </div>
          <div class="sd-body">
            <div class="sd-attributes thin-scrollbar">
              <div class="sd-section-label">{{ $t('skills.proficiencies.by_attribute') }}</div>
              <div class="sd-section-hint">{{ $t('skills.proficiencies.attribute_hint') }}</div>
              <div v-for="(attr, index) in modalAttributes" :key="'sd_attr_' + index" class="sd-attr-row">
                <div class="sd-attr-label">{{ attr.label }}</div>
                <div class="sd-attr-bar">
                  <div class="track"><div class="fill is-str" :style="{ width: attr.excels + '%' }"></div></div>
                  <span class="pct">{{ attr.excels }}%</span>
                </div>
                <div class="sd-attr-bar">
                  <div class="track"><div class="fill is-dev" :style="{ width: attr.improve + '%' }"></div></div>
                  <span class="pct">{{ attr.improve }}%</span>
                </div>
              </div>
            </div>
            <div class="sd-members thin-scrollbar">
              <div class="sd-group-label">
                <span class="swatch is-str"></span>{{ modalExcelMembers.length }} {{ $t('skills.proficiencies.members_excel') }}
              </div>
              <div class="sd-member-grid">
                <div v-for="member in modalExcelMembers" :key="'sd_excel_' + member.id" class="sd-member-card"
                  :class="[ blurMode ? 'blurelement' : '' ]">
                  <img v-if="member.imageProfile" v-lazy="member.imageProfile" :key="'sd_excel_pic_' + member.id"
                    class="image-skeleton image-profile-32 flex-mid" />
                  <div v-else class="image image-profile-32 flex-mid">
                    <div class="text-in-image text-in-image-32 flex-mid">
                      {{ $utils("acronymName", { fullName: member.name }) }}
                    </div>
                  </div>
                  <div class="sd-member-text">
                    <span class="sd-member-name">{{ member.name }}</span>
                    <span class="sd-member-team">{{ member.teamname }}</span>
                  </div>
                  <el-tooltip v-if="member.total > 1" :content="member.total + ' ' + $t('skills.proficiencies.mentions_label')" placement="top">
                    <span class="sd-member-count is-str">×{{ member.total }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="sd-group-label mt-28">
                <span class="swatch is-dev"></span>{{ modalImproveMembers.length }} {{ $t('skills.proficiencies.members_could_improve') }}
              </div>
              <div class="sd-member-grid">
                <div v-for="member in modalImproveMembers" :key="'sd_improve_' + member.id" class="sd-member-card"
                  :class="[ blurMode ? 'blurelement' : '' ]">
                  <img v-if="member.imageProfile" v-lazy="member.imageProfile" :key="'sd_improve_pic_' + member.id"
                    class="image-skeleton image-profile-32 flex-mid" />
                  <div v-else class="image image-profile-32 flex-mid">
                    <div class="text-in-image text-in-image-32 flex-mid">
                      {{ $utils("acronymName", { fullName: member.name }) }}
                    </div>
                  </div>
                  <div class="sd-member-text">
                    <span class="sd-member-name">{{ member.name }}</span>
                    <span class="sd-member-team">{{ member.teamname }}</span>
                  </div>
                  <el-tooltip v-if="member.total > 1" :content="member.total + ' ' + $t('skills.proficiencies.mentions_label')" placement="top">
                    <span class="sd-member-count is-dev">×{{ member.total }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <div>
      <el-dialog :visible.sync="detailsModalMember" width="704px" height="811" top="8vh">
        <div class="flex-column">
          <div class="fs-20 fw-700" style="margin-top: -20px;">{{ $t('skills.proficiencies.peer_feedback_rating') }}</div>
          <div class="flex-row mt-16">
            <el-input class="input-style" style="height: 40px" autosize :placeholder="$t('members.Search')"
              @keyup.native="searchData(inputSearch)" v-model="inputSearch" clearable></el-input>
            <div class="pl-20">
              <svg
                    @click="exportdata()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
                    />
                  </svg>
            </div>
          </div>
          <div class="mt-46">
            <el-table :data="members">
              <el-table-column prop="rank" :label="$t('skills.proficiencies.rank')" width="60" align="center"></el-table-column>
              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img v-if="scope.row.profilepic" v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]" />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
        $utils("acronymName", {
          firstName: scope.row.firstname,
          lastName: scope.row.lastname,
        })
      }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="name" sortable="custom" :label="$t('members.Member')" width="184">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-name"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.firstname }} {{ scope.row.lastname }}</span>
                    <span class="text-email"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="ratingavg" :label="$t('skills.proficiencies.average_rating')" width="180" align="center">
                <template slot-scope="scope">
                  <span v-if="parseFloat(scope.row.ratingavg) > 0" class="star-rating">
                    <span class="stars"><span class="stars-bg">★★★★</span><span class="stars-fg" :style="{ width: starWidth(scope.row.ratingavg) }">★★★★</span></span>
                    <span class="star-num">{{ scope.row.ratingavg }}</span>
                  </span>
                  <span v-else>{{ scope.row.ratingavg }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="interaction" :label="$t('skills.proficiencies.interactions')" width="180" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="flex-center pagination mt-10">
            <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="10" :pager-count="5"
              layout="prev, pager, next" :total="totol_data"></el-pagination>
            <span class="results-status">
              {{ totol_data > 10 ? 10 : totol_data }}
              {{ $t("members.results_from") }}
              {{ $utils("addCommasInNumber", totol_data) }}
              {{ $t("members.results") }}
            </span>
          </div>
        </div>
      </el-dialog>
    </div>


  </div>

</template>

<script>
import { resolveTeamScope } from "@/store/utils/teamScope";

export default {
  name: "proficiencies",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("team/getTeamsOptionsFixed", this.user);
    //this.$store.dispatch("insightsManagers/getDataAll");
    this.$store.dispatch("skillOverview/getOrganization1level");
    // this.$store.dispatch("skillOverview/getData");
  },
  watch: {
    optionsTeam() {
      if (this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    selectTeam() {
      this.$store.dispatch("insightsManagers/setTeamSorting", this.selectTeam);
    },
    inputSearch() {
      setTimeout(() => {
        this.searchData(this.inputSearch)
      }, 500);
    },

  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    isLeadershipUser() {
      return this.user && this.user.user_type === "leadership";
    },
    activeTeamKey() {
      if (this.isLeadershipUser) {
        return this.user && this.user.team ? this.user.team : this.selectTeam;
      }
      return this.selectTeam;
    },
    optionsTeam() {
      return this.$store.getters["team/teamsfixedall"];
    },
    loading() {
      return this.$store.getters["skillOverview/loading"];
    },
    datachart() {
      return this.$store.getters["skillOverview/datachart"];
    },
    max_y() {
      return this.$store.getters["skillOverview/max_y"];
    },
    max_x() {

      return this.$store.getters["skillOverview/max_x"];
    },
    skillProficiencyAndDeficiency() {

      return this.$store.getters["skillOverview/skillProficiencyAndDeficiency"];
    },
    checkedSkillTypeOption() {
      return this.$store.getters["skillOverview/checkedSkillTypeOption"];
    },
    attributes() {
      return this.$store.getters["skillOverview/attributes"];
    },
    userData() {
      return this.$store.getters["skillOverview/userData"];
    },
    highest() {
      return this.$store.getters["skillOverview/highest"];
    },
    lowest() {
      return this.$store.getters["skillOverview/lowest"];
    },
    skillexcel() {
      return this.$store.getters["skillOverview/skillexcel"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    // datachart is [truly, exceeding, meets, needs] counts on the 4-point scale
    ratingTiers() {
      const counts = this.datachart || [];
      return [
        { key: "truly_outstanding", color: "#6C30CC", value: 4, count: counts[0] || 0 },
        { key: "exceeding_expectations", color: "#8858d5", value: 3, count: counts[1] || 0 },
        { key: "meeting_expectations", color: "#c1a9e8", value: 2, count: counts[2] || 0 },
        { key: "needs_improvement", color: "#FFD570", value: 1, count: counts[3] || 0 }
      ];
    },
    ratingTotals() {
      let total = 0;
      let weighted = 0;
      this.ratingTiers.forEach(tier => {
        total += tier.count;
        weighted += tier.count * tier.value;
      });
      return { total, avg: total > 0 ? Math.round((weighted / total) * 10) / 10 : 0 };
    },
    // every skillexcel item carries both sides (excel/improve as strings,
    // compare deltas, member lists) — sort a mapped copy, never the getter array
    skillBalance() {
      return this.skillexcel
        .map(data => ({
          data: data,
          name: data.name,
          excel: parseInt(data.excel) || 0,
          improve: parseInt(data.improve) || 0,
          compareexcel: data.compareexcel,
          compareimprove: data.compareimprove,
          strengthPeople: data.excelsAt && data.excelsAt.members ? data.excelsAt.members.length : 0,
          developPeople: data.couldFurtherImprove && data.couldFurtherImprove.members ? data.couldFurtherImprove.members.length : 0,
          total: (parseInt(data.excel) || 0) + (parseInt(data.improve) || 0)
        }))
        .filter(skill => skill.total > 0)
        .sort((a, b) => b.total - a.total);
    },
    topSkillRows() {
      return this.skillBalance.slice(0, 10);
    },
    maxMention() {
      let max = 0;
      this.topSkillRows.forEach(skill => {
        if (skill.excel > max) max = skill.excel;
        if (skill.improve > max) max = skill.improve;
      });
      return max;
    },
    // attribute scores arrive as strings; one merged list replaces the old
    // duplicated excels/improve lists so both sides compare on the same row
    modalAttributes() {
      return (this.skillsModalData.attributes || [])
        .map(attr => ({
          label: attr.label,
          excels: Number(attr.excelsScore) || 0,
          improve: Number(attr.couldFurtherImproveScore) || 0
        }))
        .sort((a, b) => b.excels - a.excels || b.improve - a.improve);
    },
    modalSplit() {
      const excel = parseInt(this.skillsModalData.excel) || 0;
      const improve = parseInt(this.skillsModalData.improve) || 0;
      const total = excel + improve;
      return {
        total,
        excel: total > 0 ? (excel / total) * 100 : 0,
        improve: total > 0 ? (improve / total) * 100 : 0
      };
    },
    modalExcelMembers() {
      const members = (this.skillsModalData.excelsAt && this.skillsModalData.excelsAt.members) || [];
      return [...members].sort((a, b) => (b.total || 0) - (a.total || 0));
    },
    modalImproveMembers() {
      const members = (this.skillsModalData.couldFurtherImprove && this.skillsModalData.couldFurtherImprove.members) || [];
      return [...members].sort((a, b) => (b.total || 0) - (a.total || 0));
    },
    // Period-over-period deltas only make sense when a comparable baseline was
    // loaded. Initial rollup data has one; raw selector rebuilds do not.
    showDeltas() {
      // A selector change rebuilds from raw feedback without fetching a second,
      // prior-period dataset, so do not present a misleading zero change.
      return !this.periodRebuiltFromRaw && this.list_month_select !== "All-time";
    },
    behaviorLoading() {
      return this.$store.getters["skillOverview/peerBehaviorLoading"];
    },
    behaviorRows() {
      return this.$store.getters["skillOverview/peerBehaviorRows"] || [];
    },
    // selected team plus all its sub-teams, matching how getData scopes the
    // proficiency data
    behaviorTeamScope() {
      if (this.activeTeamKey === "all" || this.activeTeamKey === "") return null;
      return resolveTeamScope(
        this.activeTeamKey,
        this.$store.getters["skillOverview/organization1level"],
        this.$store.getters["main/allTeam"]
      );
    },
    scopedBehaviorRows() {
      if (!this.behaviorTeamScope) return this.behaviorRows;
      return this.behaviorRows.filter(row => this.behaviorTeamScope[row.team]);
    },
    behaviorTotals() {
      let requested = 0;
      let given = 0;
      let active = 0;
      this.scopedBehaviorRows.forEach(row => {
        requested += row.requested;
        given += row.given;
        if (row.requested > 0 || row.given > 0) active++;
      });
      const members = this.scopedBehaviorRows.length;
      return {
        requested,
        given,
        participation: members > 0 ? Math.round((active / members) * 100) : 0
      };
    },
    filteredBehaviorRows() {
      let rows = this.scopedBehaviorRows;
      const query = this.behaviorSearch.trim().toLowerCase();
      if (query) {
        rows = rows.filter(row =>
          `${row.firstname || ""} ${row.lastname || ""}`.toLowerCase().includes(query) ||
          (row.email || "").toLowerCase().includes(query) ||
          (row.teamname || "").toLowerCase().includes(query)
        );
      }
      const { prop, order } = this.behaviorSort;
      if (prop && order) {
        const direction = order === "ascending" ? 1 : -1;
        rows = [...rows].sort((a, b) => {
          if (prop === "name") {
            const nameA = `${a.firstname || ""} ${a.lastname || ""}`.toLowerCase();
            const nameB = `${b.firstname || ""} ${b.lastname || ""}`.toLowerCase();
            return nameA < nameB ? -direction : nameA > nameB ? direction : 0;
          }
          // "—" cells (no rating / never asked) always sort last, in both
          // directions, so ascending surfaces the lowest real values (e.g. the
          // least-responsive members) instead of a wall of blanks
          const aNull = a[prop] === null || a[prop] === undefined;
          const bNull = b[prop] === null || b[prop] === undefined;
          if (aNull && bNull) return 0;
          if (aNull) return 1;
          if (bNull) return -1;
          return (a[prop] - b[prop]) * direction;
        });
      }
      return rows;
    },
    pagedBehaviorRows() {
      const start = (this.behaviorPage - 1) * this.behaviorPageSize;
      return this.filteredBehaviorRows.slice(start, start + this.behaviorPageSize);
    },
  },
  data() {
    return {
      selectTeam: "",
      SortBy: "Proficiency",
      userDetail: {},
      detailsModalStatus: false,
      // checkedSkillTypeOption: [{ type: "Details" }, { type: "Risk-taking" }],
      skillFilterList: [],
      checkedSkillType: [],
      detailsModalMember: false,
      inputSearch: '',
      page: 1,
      totol_data: 0,
      data_dialog: [],
      behaviorSearch: "",
      behaviorPage: 1,
      behaviorPageSize: 10,
      behaviorSort: { prop: null, order: null },
      // mock data
      // skillProficiencyAndDeficiency: [
      //   {
      //     name: "Details",
      //     id: "details",
      //     excelsAt: {
      //       solid: 40,
      //       gradientFill: 60,
      //       members: [
      //         {
      //           name: "John Doe1",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 90,
      //         },
      //         {
      //           name: "John Doe2",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 20,
      //         },
      //         {
      //           name: "John Doe3",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 0,
      //         },
      //         {
      //           name: "John Doe4",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 1,
      //         },
      //         {
      //           name: "John Doe5",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 50,
      //         },
      //         {
      //           name: "John Doe6",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe7",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe8",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe9",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },

      //       ],
      //     },
      //     couldFurtherImprove: {
      //       solid: 20,
      //       gradientFill: 45,
      //       members: [
      //         {
      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //       ],
      //     },
      //   },
      //   {
      //     name: "Risk-taking",
      //     id: "Risk-taking",
      //     excelsAt: {
      //       solid: 40,
      //       gradientFill: 60,
      //       members: [
      //         {
      //           name: "John Doe",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //       ],
      //     },
      //     couldFurtherImprove: {
      //       solid: 20,
      //       gradientFill: 45,
      //       members: [
      //         {
      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           scorePercentage: 20,
      //         },
      //       ],
      //     },
      //   },
      // ],
      // lowest:[{

      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           star: "2.0",
      //           firstName:'John',
      //           lastName:'Doec'

      // },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      }],
      // highest:[{

      //                name: "John Doec1",
      //                id: "john-doec1",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John1',
      //                 lastName:'Doec1'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      }],
      skillProficiencyAndDeficiencyModalStatus: false,
      list_month_select: "Past 6-months",
      periodRebuiltFromRaw: false,
      skillsModalData: {
        name: "",
        id: "",
        excelsAt: {
          solid: 0,
          gradientFill: 0,
          members: [],
        },
        couldFurtherImprove: {
          solid: 0,
          gradientFill: 0,
          members: [],
          attributes: [],
        },
      },
      members: [{

      }],
      data_Search: []
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
    }
    this.$store.dispatch("skillOverview/getPeerFeedbackBehaviors", this.list_month_select);
  },
  methods: {
    exportdata() {
      let data = []
      if (this.inputSearch != '') {
        data = this.data_Search;
      } else {
        data = this.data_dialog;
      }

      const Excel = require('exceljs');
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet('peer-feeedback-ratings');
      let company = ''
      /*TITLE*/
      ws.getRow(1).height = 20
      ws.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
      ws.getCell('A1').alignment = { vertical: 'middle' }
      // ws.getCell('A1').value = `${company.name} Performance Review Data Downloaded on ${format(new Date(),'MMMM DD,YYYY')}`

      // /*Column headers*/
      ws.getColumn('A').width = 25;
      ws.getColumn('B').width = 10;
      ws.getColumn('C').width = 10;
      ws.getColumn('D').width = 10;
      ws.getColumn('E').width = 10;
      ws.getRow(1).values = ['Rank', 'Name completed', 'Team', 'Average Rating', 'Interactions']

      // /*Data*/
      _.forEach(data, (item, key) => {
        company = item.company
        let _tmp = [
          item.rank,
          item.firstname + ' ' + item.lastname,
          item.teamname,
          item.ratingavg,
          item.total,

        ];
        ws.addRow(_tmp);

      });




      wb.xlsx.writeBuffer({
        base64: true
      })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = company + '-peer-feeedback-ratings' + ".xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          },
            0);
        })
        .catch(function (error) {
          console.log(error.message);
        });


    },
    isSingleMonth(time) {
      return time === "Current month" || time === "Last month";
    },
    changeTime(time) {
      this.list_month_select = time;
      this.periodRebuiltFromRaw = true;
      this.behaviorPage = 1;
      // Summary panels and the behavior table now share one cached raw-feedback
      // query, so recent periods do not depend on a potentially stale rollup.
      this.$store.dispatch("skillOverview/getPeerFeedbackPeriod", { value: time, team: this.activeTeamKey });
      this.$store.dispatch("skillOverview/getPeerFeedbackBehaviors", time);
    },
    openModalDetails(data) {
      // console.log(data.couldFurtherImprove)
      // console.log(data.couldFurtherImprove.solid)

      // TODO: Add data to modal
      this.skillsModalData = data;
      this.skillsModalData.attributes = this.attributes[data.name]
      this.detailsModalStatus = true;
      // [
      //   {
      //     label: "Paying close attention to small details",
      //     excelsScore: 80,
      //     couldFurtherImproveScore: 20,
      //   },
      //   {
      //     label: "Taking the time to thoroughly complete a task",
      //     excelsScore: 40,
      //     couldFurtherImproveScore: 39,
      //   },
      //   {
      //     label: "Critically evaluating information",
      //     excelsScore: 52,
      //     couldFurtherImproveScore: 14,
      //   },
      // ];
    },
    openModalMember(data, type) {
      // console.log('this.highest.slice(0,10);',this.highest.slice(0,10))
      for (const i in data) {
        if (type == 'highest') {
          data[i].rank = data[i].rank_highest
        } else {
          data[i].rank = data[i].rank_lowest
        }
      }
      this.inputSearch = ''
      this.data_dialog = data;
      this.detailsModalMember = true;
      this.members = data.slice(0, 10);
      this.totol_data = data.length;

    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.inputSearch != '') {
        this.members = this.data_Search.slice(((val - 1) * 10), (10 * val));
      } else {
        this.members = this.data_dialog.slice(((val - 1) * 10), (10 * val));
      }


    },
    searchData(val) {
      var re = new RegExp(val, 'gi')
      let _tableData = []
      for (const key in this.data_dialog) {
        const tableData = this.data_dialog

        if (tableData[key].firstname.match(re)) {
          _tableData.push(tableData[key])
        } else if (tableData[key].lastname.match(re)) {
          _tableData.push(tableData[key])
        }
      }
      this.data_Search = _tableData;
      this.totol_data = _tableData.length;
      this.members = _tableData.slice(0, 10);
    },
    handleSelectAllSkillType() {
      if (this.checkedSkillType.length !== this.checkedSkillTypeOption.length) {
        let checked = [];
        for (const i in this.checkedSkillTypeOption) {
          checked.push(this.checkedSkillTypeOption[i].type);
        }
        this.checkedSkillType = checked;
      }
    },
    clearQuestionTypeSelected() {
      this.checkedSkillType = this.skillFilterList;
      this.$refs.dropdownValuesMenu.visible = false;
    },
    saveQuestionTypeFiltered() {
      this.skillFilterList = this.checkedSkillType;
      this.$store.dispatch("skillOverview/filtersData", this.checkedSkillType);

      this.$refs.dropdownValuesMenu.visible = false;
    },
    renderMemberPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    handleTeams(key) {
      const scopedKey = this.isLeadershipUser ? this.user.team : key;
      this.selectTeam = scopedKey;
      this.behaviorPage = 1;
      // Team changes only re-aggregate cached period records; no refetch needed.
      this.$store.dispatch("skillOverview/getPeerFeedbackPeriod", { value: this.list_month_select, team: scopedKey });
    },
    sortBy(type) {
      this.SortBy = type;
      this.$store.dispatch("skillOverview/sortData", type);
    },
    sortBehaviors({ prop, order }) {
      this.behaviorSort = { prop, order };
      this.behaviorPage = 1;
    },
    changeBehaviorPage(page) {
      this.behaviorPage = page;
    },
    barWidth(count) {
      if (!this.maxMention || count <= 0) return "0%";
      return Math.max(3, Math.round((count / this.maxMention) * 100)) + "%";
    },
    skillTooltip(mentions, people) {
      return `${this.formatNumber(mentions)} ${this.$t("skills.proficiencies.mentions_label")} · ${this.formatNumber(people)} ${this.$t("skills.proficiencies.people_label")}`;
    },
    formatNumber(num) {
      if (num === undefined || num === null || isNaN(num)) return "0";
      return this.$utils ? this.$utils("addCommasInNumber", num) : num.toString();
    },
    getPointRadius() {
      let radiusArr = [];
      for (const i in this.datachart) {
        let minnimaxRadius = 0,
          maxRadius = 3;
        let directReport = this.datachart[i].size;
        let redius = this.datachart[i].size;//Math.trunc(directReport / 5 + (minnimaxRadius - 1));
        radiusArr.push(redius * 2);
        // if (redius < minnimaxRadius) {
        //   radiusArr.push(minnimaxRadius);
        // } else if (redius > maxRadius) {
        //   radiusArr.push(maxRadius);
        // } else {
        //   radiusArr.push(redius);
        // }
      }
      return radiusArr;
    },
    getPointColor() {
      let colorArr = [];
      for (const i in this.datachart) {
        // TODO: Fix color of node on here
        if (this.datachart[i].type == "excel") {
          colorArr.push("#00ACC1");
        } else if (this.datachart[i].type == "improves") {
          colorArr.push("#E45006");
        }
        //else {
        //   colorArr.push("#f44336");
        // }
      }
      return colorArr;
    },
    getPointTitle() {
      let title = [];
      for (const i in this.datachart) {
        // TODO: Fix label of node on here
        title.push(this.datachart[i].name);
      }
      return title;
    },
    tierPercent(tier) {
      if (!this.ratingTotals.total) return 0;
      return Math.round((tier.count / this.ratingTotals.total) * 100);
    },
    // fill width for the 4-star rating display; showing four stars makes the
    // out-of-4 ceiling explicit instead of leaving it to an implied 5-star read
    starWidth(avg) {
      const v = parseFloat(avg);
      if (isNaN(v) || v <= 0) return "0%";
      return Math.min(100, (v / 4) * 100) + "%";
    },
  },
};
</script>

<style lang="scss" scoped>
.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}

.menu-option-style {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.chart-container {
  position: relative;
  height: 290px;
  margin-top: 16px;
  padding: 24px 24px 36px 48px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 24px;
}

.site-text {
  transform: rotate(-90deg);
  width: 300px;
  position: absolute;
  margin-top: 90px;
  margin-left: -128px;
}

.image-profile-32 {
  border: 2px solid #ffffff;
}

.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32c2d5, 0.1);
  padding: 0 6px 0 10px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32c2d5, 0.1);
  padding: 0 6px 0 10px;
}

.text-drop-down {
  color: #00acc1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

/* Skill Details dialog — qd-style header (eyebrow + title + split mention
   bar) over a two-column body: merged attribute list, member grids */
.sd-header {
  padding: 28px 32px 22px;
  border-bottom: 1px solid #eef0f5;
}

.sd-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8a8a;
}

.sd-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin-top: 4px;
}

.sd-mentions {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 18px;

  .sd-mention-stat {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    &.is-end {
      align-items: flex-end;
    }

    .n {
      font-size: 20px;
      font-weight: 800;
      color: #1a1a1a;
    }

    .label {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      color: #8a8a8a;
      margin-top: 2px;
    }
  }

  .sd-mention-bar {
    flex: 1;
    display: flex;
    height: 10px;
    border-radius: 999px;
    overflow: hidden;
    background: #eef0f5;

    .seg {
      min-width: 4px;

      &.is-str {
        background: transparent linear-gradient(90deg, #1DA2B4 0%, #32C2D5 100%) 0% 0% no-repeat padding-box;
      }

      &.is-dev {
        background: transparent linear-gradient(90deg, #E45006 0%, #C34B0F 100%) 0% 0% no-repeat padding-box;
      }

      & + .seg {
        margin-left: 2px;
      }
    }
  }
}

.sd-body {
  display: grid;
  grid-template-columns: 400px 1fr;

  .sd-attributes,
  .sd-members {
    padding: 22px 28px 28px;
    max-height: 62vh;
    overflow-y: auto;
  }

  .sd-attributes {
    background: #fafbfd;
    border-right: 1px solid #eef0f5;
  }
}

.sd-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8a8a;
}

.sd-section-hint {
  font-size: 12px;
  color: #9a9a9a;
  margin-top: 4px;
}

.sd-attr-row {
  padding: 14px 0 2px;

  & + .sd-attr-row {
    border-top: 1px solid #eef0f5;
    margin-top: 12px;
  }

  &:first-of-type {
    margin-top: 6px;
  }

  .sd-attr-label {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 8px;
  }

  .sd-attr-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 3px 0;

    .track {
      flex: 1;
      height: 6px;
      border-radius: 999px;
      background: #eef0f5;
      overflow: hidden;

      .fill {
        height: 100%;
        border-radius: 999px;

        &.is-str {
          background: #00ACC1;
        }

        &.is-dev {
          background: #E45006;
        }
      }
    }

    .pct {
      width: 36px;
      text-align: right;
      font-size: 12px;
      font-weight: 700;
      color: #626262;
      flex-shrink: 0;
    }
  }
}

.sd-group-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}

.sd-wrap .swatch {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  flex-shrink: 0;

  &.is-str {
    background: #00ACC1;
  }

  &.is-dev {
    background: #E45006;
  }
}

.sd-member-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.sd-member-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e2e4ea;
  border-radius: 8px;
  min-width: 0;

  .sd-member-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
  }

  .sd-member-name {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sd-member-team {
    font-size: 11px;
    color: #9a9a9a;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sd-member-count {
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
    cursor: default;

    &.is-str {
      color: #00ACC1;
    }

    &.is-dev {
      color: #E45006;
    }
  }
}

.line-of-middle-chart {
  width: 100%;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% - 14%);
    height: 1px;
    background: #ccc;
    transform: translate(-50%, -50%);
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1px;
    height: calc(100% - 16%);
    background: #ccc;
    transform: translate(-50%, -50%);
  }
}

.widht-label-of-chart {
  top: 0;
  position: absolute;
  width: 100%;

  .label-container {
    opacity: 0.5;
    font-size: 10px;
    color: #000;
    display: flex;
    justify-content: space-between;
    padding: 0 20px 0 22px;

    >div {
      width: 20px;
      display: flex;
      justify-content: center;
    }
  }
}

.skill-Profictency {
  top: 621px;
  left: 334px;
  min-width: 868px;
  min-height: 498px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
  opacity: 1;
}

.overview {
  min-width: 868px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
  padding: 24px;
}

.rating-grid {
  display: grid;
  grid-template-columns: 1.15fr 1fr 1fr;
  column-gap: 24px;

  .rating-col + .rating-col {
    border-left: 1px solid #eef0f5;
    padding-left: 24px;
  }
}

.rating-stats {
  display: flex;
  gap: 32px;
  padding: 18px 0 14px;
}

.rating-stat {
  display: flex;
  flex-direction: column;

  .rating-stat-value {
    font-size: 22px;
    font-weight: 800;
    color: #1a1a1a;

    .star-rating {
      margin-left: 10px;
      vertical-align: 3px;
    }
  }

  .rating-stat-label {
    font-size: 12px;
    color: #8a8a8a;
    margin-top: 2px;
  }
}

.rating-bar {
  display: flex;
  height: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: #eef0f5;

  .rating-bar-seg {
    min-width: 4px;

    & + .rating-bar-seg {
      margin-left: 2px;
    }
  }
}

.rating-legend {
  padding-top: 14px;

  .rating-legend-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
  }

  .rating-legend-swatch {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    flex-shrink: 0;
  }

  .rating-legend-label {
    font-size: 12px;
    color: #4a4a4a;
    flex: 1;
    min-width: 0;
  }

  .rating-legend-count {
    font-size: 12px;
    font-weight: 700;
    color: #1a1a1a;
  }

  .rating-legend-pct {
    font-size: 11px;
    color: #9a9a9a;
    width: 34px;
    text-align: right;
  }
}

.rating-empty {
  margin-top: 18px;
  padding: 18px;
  text-align: center;
  color: #999;
  font-style: italic;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
}

.rated-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;

  .rated-rank {
    width: 14px;
    font-size: 12px;
    color: #9a9a9a;
    text-align: center;
    flex-shrink: 0;
  }

  .rated-who {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;

    .rated-name {
      font-size: 13px;
      font-weight: 600;
      color: #1a1a1a;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .rated-team {
      font-size: 11px;
      color: #9a9a9a;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .rated-score {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;

    .rated-rating {
      font-size: 13px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .rated-count {
      font-size: 11px;
      color: #9a9a9a;
      margin-top: 1px;
    }
  }
}

/* muted "/ 4" denominator shown where the 4-star row doesn't fit (the
   compact Highest/Lowest lists and the dense behaviors table) so the
   out-of-4 ceiling stays explicit without the width of a star row */
.rating-denom {
  font-size: 11px;
  font-weight: 600;
  color: #b0b3bb;
  margin-left: 2px;
}

.rated-see-all {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #6c30cc;
  cursor: pointer;

  &:hover {
    color: #522698;
  }
}

/* Strengths & development diverging bars (replaces the old bar-excel /
   bar-improve two-column lists; same teal/orange convention) */
.sb-chart {
  padding: 12px 0 6px;
}

.sb-head {
  display: flex;
  align-items: center;
  padding: 6px 0 10px;
}

.sb-row {
  display: flex;
  align-items: center;
  padding: 9px 0;

  &:hover {
    background: #fafbfc;
  }
}

.sb-skill {
  width: 180px;
  flex-shrink: 0;
  min-width: 0;
}

.sb-skill-name {
  font-size: 13px;
  color: #000000;
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sb-track {
  flex: 1;
  display: flex;
  align-items: center;
  align-self: stretch;
  min-width: 0;
}

.sb-side {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  &.is-dev {
    justify-content: flex-end;
    padding-right: 10px;
  }

  &.is-str {
    padding-left: 10px;
  }
}

.sb-axis {
  width: 1px;
  align-self: stretch;
  margin: -9px 0;
  background: #e2e4ea;
  flex-shrink: 0;
}

.sb-head .sb-axis {
  margin: -6px 0 -10px;
}

.sb-bar {
  height: 10px;
  border-radius: 999px;

  &.is-dev {
    background: transparent linear-gradient(270deg, #C34B0F 0%, #E45006 100%) 0% 0% no-repeat padding-box;
  }

  &.is-str {
    background: transparent linear-gradient(90deg, #1DA2B4 0%, #32C2D5 100%) 0% 0% no-repeat padding-box;
  }
}

.sb-count {
  font-size: 12px;
  font-weight: 700;
  color: #626262;
  flex-shrink: 0;
}

.sb-delta {
  font-size: 10px;
  flex-shrink: 0;
}

.sb-axis-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8a8a;

  .swatch {
    width: 8px;
    height: 8px;
    border-radius: 999px;

    &.is-dev {
      background: #E45006;
    }

    &.is-str {
      background: #00ACC1;
    }
  }
}

.sb-footnote {
  font-size: 12px;
  color: #9a9a9a;
  padding-top: 10px;
}

.sb-empty {
  margin-top: 16px;
  padding: 24px;
  text-align: center;
  color: #999;
  font-style: italic;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
}

/* Feedback behaviors by person */
.behaviors-card {
  min-width: 868px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
  overflow: hidden;
}

.behaviors-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding: 20px 24px 16px;
}

.behaviors-stats {
  display: flex;
  gap: 28px;
  flex-shrink: 0;

  .behaviors-stat {
    display: flex;
    flex-direction: column;
    align-items: center;

    .stat-value {
      font-size: 20px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .stat-label {
      font-size: 12px;
      color: #8a8a8a;
      margin-top: 2px;
      white-space: nowrap;
    }
  }
}

.behaviors-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: #fafbfd;
  border-top: 1px solid #eef0f5;
  border-bottom: 1px solid #eef0f5;
}

.behaviors-meta {
  font-size: 13px;
  color: #8a8a8a;
}

.behaviors-search {
  width: 240px;

  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-radius: 8px;
    border-color: #e2e4ea;
  }
}

#behaviorsTable {
  ::v-deep th:first-child .cell,
  ::v-deep td:first-child .cell {
    padding-left: 24px;
  }

  /* multi-level headers switch el-table into group mode, which draws a
     border on every cell — keep the table clean like the rest of the app */
  ::v-deep .el-table__cell {
    border-right: none;
  }

  ::v-deep th.is-group {
    border-right: none;
  }
}

.behaviors-member {
  display: flex;
  align-items: center;
  gap: 12px;

  .behaviors-member-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .behaviors-name {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .behaviors-team {
    font-size: 12px;
    color: #9a9a9a;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* dotted underline = "hover for definition" cue on hinted headers/labels */
.behaviors-th {
  text-decoration: underline dotted #c0c4cc;
  text-underline-offset: 3px;
  cursor: help;
}

.behaviors-count {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;

  &.is-zero {
    color: #c0c4cc;
    font-weight: 500;
  }
}

.behaviors-rating {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

.behaviors-rate {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

/* 4-star rating display — kept only where there's room to read it (the
   Rating Overview headline and the roomy Peer Feedback Rating dialog); the
   gold layer is clipped by width to the score. Tight inline cells use the
   plain number + .rating-denom instead */
.star-rating {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  .stars {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    font-size: 13px;
    line-height: 1;
    letter-spacing: 2px;
  }

  .stars-bg {
    color: #e2e4ea;
  }

  .stars-fg {
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    white-space: nowrap;
    color: #F7B924;
  }

  .star-num {
    font-size: 13px;
    font-weight: 700;
    color: #1a1a1a;
  }

  &.is-lg .stars {
    font-size: 16px;
  }
}

.behaviors-pagination {
  display: flex;
  justify-content: center;
  padding: 12px 0 18px;

  /* Element UI ships a blue (#409EFF) active pager; this app has no global
     pager theme, so recolor the active page and hover states to brand purple */
  ::v-deep .el-pager li.active {
    color: #6c30cc;
  }

  ::v-deep .el-pager li:not(.disabled):hover,
  ::v-deep .el-pagination button:not(:disabled):hover {
    color: #6c30cc;
  }
}

.loading-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  margin: 20px 24px;
  color: #999;
  font-style: italic;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;

  i {
    margin-right: 10px;
    color: #666;
  }
}

.menuOptionPowerup {
  width: 200px;
  border-radius: 4px;
  height: 40px;
}
</style>

<style lang="scss">
#menuDropdownType .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
</style>
